//
//
//
//
//
//
//
//
import { checkWeChatMessage } from "@/api/module";
export default {
  name: "index",
  data: function data() {
    return {
      htmlTitle: null,
      htmlValue: null
    };
  },
  created: function created() {
    var id = JSON.parse(this.$route.query.item);
    this.getWeChatMessage(id);
  },
  filters: {
    typeFilter: function typeFilter(type) {
      if (type && type != '') {
        switch (type) {
          case '2':
            return '公告通知';

          case '3':
            return '健康科普';
        }
      } else {
        return "";
      }
    }
  },
  methods: {
    getWeChatMessage: function getWeChatMessage(id) {
      var _this = this;

      var param = {
        id: id
      };
      checkWeChatMessage(param).then(function (res) {
        if (res.code == 200) {
          _this.htmlTitle = res.data.title;
          _this.htmlValue = res.data.content;
        }
      });
    }
  }
};